export default __webpack_public_path__ + "static/media/bike3.df249210.png";